import { mixedResultCarouselStyle } from '../../../../common/ResultSection/ResultSection.style';

export const programPromotionCardStyle = (
  isInCarousel: boolean,
  isPreEffective: boolean,
  ctaValue?: string,
  cardHeight?: number
) => ({
  'abyss-card-root': {
    display: 'flex',
    width: '100%',
    maxWidth: '406px',
    '@screen < $md': {
      width: '100%',
      maxWidth: '406px',
    },
    '@screen < $sm': {
      width: '100%',
      maxWidth: '320px',
      marginLeft: isInCarousel ? '0' : '16px',
    },
    minHeight: cardHeight ? `${cardHeight}px` : '203px',
    height: cardHeight ? `${cardHeight}px` : 'auto',
    padding: '24px 24px 32px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    borderRadius: '8px',
    border: '1px solid #E5E5E6',
    background: '#FFF',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    marginTop: '0 !important',
    marginBottom: '0 !important',
    marginRight: '0',
    cursor: isPreEffective || !ctaValue ? 'not-allowed' : 'pointer',
    opacity: isPreEffective || !ctaValue ? 0.6 : 1,
    overflow: 'visible',
  },
  '& + .abyss-card-root': {
    marginTop: '0 !important',
  },
});

export const programPromotionSlideStyle = (
  index: number,
  count: number,
  isExpandViewAllEnabled: boolean
) => ({
  'abyss-slide-container': {
    marginLeft: index === 0 ? '0px' : '16px',
    marginRight: isExpandViewAllEnabled
      ? 0
      : count === 2 && index === 0
      ? '16px'
      : '0px',
    background: '$white',
    width: '100%',
    minWidth: '100%',
    maxWidth: '406px',
    flex: '0 0 auto',
    '@screen < $sm': {
      width: '100%',
      minWidth: '100%',
      maxWidth: '320px',
    },
  },
});

export const programPromotionDescriptionStyle = {
  width: '100%',
  lineHeight: '20px',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
  alignSelf: 'stretch',
};

export const programPromotionTitleStyle = {
  width: '100%',
  lineHeight: '24px',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
};

export const programPromotionCarouselSlideContainerStyle = {
  'abyss-carousel-slide-container': {
    width: '406px',
    minWidth: '406px',
    maxWidth: '406px',
    alignItems: 'stretch',
    '@screen < $md': {
      width: '406px',
      minWidth: '406px',
      maxWidth: '406px',
    },
    '@screen < $sm': {
      width: '320px',
      minWidth: '320px',
      maxWidth: '320px',
      marginLeft: '16px',
    },
  },
};

export const programPromotionCarouselStyle = (
  count: number,
  width: number,
  isSingleSlideView: boolean,
  isLoading?: boolean,
  isExpandViewAllFFEnabled?: boolean
) => ({
  ...mixedResultCarouselStyle(
    count,
    width,
    isLoading,
    isExpandViewAllFFEnabled
  ),
  ...(isSingleSlideView
    ? {
        'abyss-carousel-slide-container': {
          width: '100%',
          minWidth: '100%',
          maxWidth: '406px',
          marginLeft: 0,
          '@screen < $sm': {
            width: '320px',
            minWidth: '320px',
            maxWidth: '320px',
            marginLeft: '16px',
          },
        },
      }
    : programPromotionCarouselSlideContainerStyle),
});
